import React, { useEffect, useRef } from 'react';
import { decodeString } from 'lib/stringUtils';
import loadScript from 'lib/loadScript';

// dont think that this is working properly. need to compare
// with uat. for now it is rendering markup
/**
 * TweetEmbed component renders a Twitter embed widget.
 *
 * @param {object} props - The component props.
 * @param {string} props.html - The HTML content for the embed.
 * @param {import('../../../../lib/graphqlTypeDefs.mjs').Widget} props.widget - The widget object containing additional data.
 * @returns {JSX.Element} The rendered TweetEmbed component.
 */
export const TweetEmbed = ({ html, widget }) => {
  const embedRef = useRef(null);

  /**
   * This effect loads the external script for X platform widgets and sets the necessary attributes.
   * After the script is loaded, it re-parses and renders any X embeds on the page.
   * This is particularly useful in a Single Page Application (SPA) where navigating to a new article
   * does not reload the entire page, so the script needs to re-parse the new content.
   */
  useEffect(() => {
    loadScript('//platform.twitter.com/widgets.js', {
      attributes: { defer: true, charset: 'utf-8' },
    }).then(() => {
      window?.twttr?.widgets?.load(embedRef.current);
    });
  }, []);

  // Strip script tags from content.
  const markup = (html || decodeString(widget.baseline))
    .replace(/<script[^<]+src="([^"]+)"[^<]*><\/script>/gi, '');

  /* eslint-disable react/no-danger */
  return (
    <div
      ref={embedRef}
      className="embed-widget__use-presentation"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
  /* eslint-enable react/no-danger */
};

